import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../config/config';
import { Creators } from './actions';

// *************************** Fetch Reviews Banner Saga ***************************
export function* fetchInternetBannerSaga(action) {
  try {
    yield put(Creators.fetchInternetBannerStart());
    // Change the apiEndpoint below this line
    const url = yield apiEndpoints.internetBannerData;
    // console.log('url: ', url);
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const internetBannerData = [];
    if (res.status === 200) {
      // if (res.data.success === 1) {
      for (let key in res.data.Banner) {
        internetBannerData.push({
          id: key,
          ...res.data.Banner[key]
        });
      }
    }
    // console.log('internetBannerData: ', internetBannerData);
    yield put(Creators.fetchInternetBannerSuccess(internetBannerData));
  } catch (err) {
    yield put(Creators.fetchInternetBannerFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Latest Reviews Saga ***************************
export function* fetchLatestInternetSaga(action) {
  try {
    yield put(Creators.fetchLatestInternetStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield apiEndpoints.internetLatest;
      // url = yield apiEndpoints.latestInternet;
    } else {
      url = yield `${apiEndpoints.internetLatest}/page/${action.pageNumber}`;
      // url = yield `${apiEndpoints.latestInternet}/page/${action.pageNumber}`;
    }
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const latestInternet = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        latestInternet.push({
          id: res.data.categoryPosts[key].postId,
          ...res.data.categoryPosts[key]
        });
      }
    }
    yield put(
      Creators.fetchLatestInternetSuccess({
        pageNumber: action.pageNumber,
        latestInternet
      })
    );
  } catch (err) {
    yield put(Creators.fetchLatestInternetFailure(err));
  }
}
// ______________________________________________________________________________
